import { render, staticRenderFns } from "./UnitProductManagement.vue?vue&type=template&id=13b11132&scoped=true&"
import script from "./UnitProductManagement.vue?vue&type=script&lang=js&"
export * from "./UnitProductManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b11132",
  null
  
)

export default component.exports